import { Injectable } from '@angular/core';
import { Session } from './session.model';   
import { Storage } from '@capacitor/storage';
import { Router } from '@angular/router'; 
import { ToastController } from '@ionic/angular';
import { Toast } from '@capacitor/toast';

export const defaultMenu = [
  ["1","20","1","Perfil","dashboard.php","tachometer-alt"],
  ["1","22","2","Equipos","devices.php","cloud"]
 ]
;

@Injectable({
  providedIn: 'root'
})
export class SessionService {
  private data:any;
  private sesidata= new Session(
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    "na",
    "na",
    "na",
    [],
    0,
    0,
    0,
    [],
    [],
    0,
    "na",
    "na",
    "na",
    []
  );
   
   constructor(private router:Router,private toast:ToastController) { 

  } 
  sessionStart(js){   
     this.sesidata.id= js.id;
     this.sesidata.miembroID=+js.miembroID;
     this.sesidata.municipio=+js.municipio;
     this.sesidata.centro=+js.centro;
     this.sesidata.grupo=+js.grupo;
     this.sesidata.name=js.name;
     this.sesidata.foto= js.foto;
     this.sesidata.access= js.acces;
     this.sesidata.empresa=js.empresa;
     this.sesidata.lock=js.lock;
     this.sesidata.CanNot= js.CantNot;
     this.sesidata.msj=js.msj;
     this.sesidata.sky= js.skyn;
     this.sesidata.flag= js.flag;
     this.sesidata.carpeta=js.Carpeta;
     this.sesidata.moneda=js.Moneda;
     this.sesidata.token=js.Token;
     this.setVariable('MunicipioID',js.municipio);
      
   } 
   sessionEnd(){   
    this.sesidata.id=0;
    this.sesidata.miembroID=0;
    this.sesidata.municipio=0;
    this.sesidata.centro=0;
    this.sesidata.grupo=0;
    this.sesidata.name="";
    this.sesidata.foto= "";
    this.sesidata.access= [];
    this.sesidata.empresa=0;
    this.sesidata.lock=0;
    this.sesidata.CanNot= 0;
    this.sesidata.msj=[];
    this.sesidata.sky= [];
    this.sesidata.flag= 0;
    this.sesidata.carpeta="";
    this.sesidata.moneda="";
    this.sesidata.token="NA";
     
  } 

  DoToast(msj:string,dura:number,posi:number){
    Toast.show({
      text:msj,
      duration:dura==1?'short':'long',
      position:posi==1?'top':'bottom'
    })
  }

  async DoNotificacion(msj:string,flag:number,posi:number){
    let noti=   await this.toast.create(
      {
        message:msj,
        duration:2000,
        color:flag==1 ? 'success':'danger',
        position:posi==1?'top':'bottom'
      }
    );
    noti.present();
  }
  getMiembroID(){
    return this.sesidata.miembroID;
  }
  storeAuthData(){
    let dat = JSON.stringify(this.sesidata);
    if(this.sesidata.token!="NA")
    {
      Storage.set({ key: 'authData', value:dat});
    }else{
      this.clearStoreAuthData();
    }

  }
  getGrupo(){
    return this.sesidata.grupo;
  }
  getStoreAuthData(){
    this.data=null;
    Storage.get({key:'authData'}).then((result:any)=>{
        this.data=result.value;
    });
     
  }
  getMunicipio(){
    return this.sesidata.municipio;
  }
  getCentro(){
    return this.sesidata.centro;
  }
getDataST() {
  return  Storage.get({key:'authData'})
 
}
  clearStoreAuthData(){
    Storage.set({ key: 'authData', value:'NA'});
  }
  setPath(path:string){
    this.sesidata.path=path;
  }
  getActive(){
    return this.sesidata.active;
  }

  setDataAuth(data:any){
    
    this.sesidata=data;
  }
  
  getSubActive(){
    return this.sesidata.subactive;
  }
  setSubActive(id:number){
    this.sesidata.subactive=id;
  }

  setActive(id:number){
    this.sesidata.active=id;
  }
  getAccess(){
    return this.sesidata.access;
  }
 
  getMenu(){
    return [...this.sesidata.access];
  }

  getFlag(){
     if(this.sesidata.flag === 1){
        return true;
     }else{
        return false;
     }
  }
 
  getuid(){
    return  this.sesidata.id;
  }
  
  getcarpeta(){
    return  this.sesidata.carpeta;
  }
  setVariable(id,data){
    let flag=true;
    let c=0; 
    let l=0,b=0;
   console.log('Vavmos a Buscar->',id,data);
    this.sesidata.sessionvariable.forEach(element=>{
      for(var key in element){
       
          if(key==id){
            this.sesidata.sessionvariable[c]={[id]:data};
            console.log('contador',c,this.sesidata.sessionvariable);
            flag=false;
            if(l>1){
                delete this.sesidata.sessionvariable[c];
            }
            l++;
          }
          c++;
      }
  });
    if(flag && l==0)
    this.sesidata.sessionvariable.push({[id]:data});
     
  
    
}

clearVariables(){
    this.sesidata.sessionvariable=[];
}
  getVariable(id){
     let data:any;
    
    this.sesidata.sessionvariable.forEach(element=>{
        for(var key in element){
            if(key==id){
              
              data=element[key];
            }
        }
    });
    return data;
  }

  getMoneda(){
    return  this.sesidata.moneda;
  }
  getToken(){
    return  this.sesidata.token;
  }

    
  ValidateAccess(acID:number,subacID:number){
    let id:number; let subid:number;let url:string="";
    let flag=false; let suarr:any=[];
    this.sesidata.access.forEach(el=>{
       
        if(el.length==6){
            id=+el[1];
            if(id==acID){
              flag=true;  
            }
        }else{
         
          id=+el[0][1];
          suarr=el[1];
          if(suarr.length>1)
          suarr.forEach(element => {
                subid=element[3];
                if(subid==subacID){
                  flag=true;   
                }
          });
        }
    });
    url='/SIGET/'+this.sesidata.access[0][3];
    if(!flag)this.router.navigateByUrl(url);
  }
}
